import React from 'react';

import '../../../css/main_menu.css';

import { connect } from 'react-redux';

import { withModalHandler } from '../../../HOC/ModalHandler';

import { index as fetchPartners } from '../../../API/Partners';

/**
 * CreditDisplayer
 */
class CreditDisplayer extends React.Component {

  constructor(props){
    super(props);

    this.fetchPartners = this.props.modalHandler.addVerificationWithCallback(fetchPartners, this.updatePartner);

    this.state = {
      amount: null
    }
  }

  componentDidMount() {
    if(this.props.credentials.roles.includes('ROLE_USER') && !this.props.credentials.roles.includes('ROLE_NYUKOM')) {
      this.fetchPartners(1, 0, {}, 'ASC', 'credit')
    }
  }

  updatePartner = (data) => {
    if(data.items.length === 1 && data.items[0].accounts.length === 1) {
      this.setState({
        amount: data.items[0].accounts[0]["client_credit_amount"]?data.items[0].accounts[0]["client_credit_amount"]["current_amount"]:0
      })
    }
  }

  /**
   * LeftMenu render method for React Component
   */
  render() {
    if(this.state.amount === null) {
      return <div/>
    }

    return (
      <div className="d-flex flex-column left-menu-credit-container">
        <div className="d-flex flex-row justify-content-center align-items-center">
          <div className="left-menu-credit-text">Mes CREDITS</div>
        </div>
        <div className="d-flex flex-row justify-content-center align-items-center">
          <div className="d-flex left-menu-credit">{this.state.amount}</div>
          <i className="icon-kredits-icons"/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  credentials: state.persisted.credentials
})

export default connect(mapStateToProps)(withModalHandler(CreditDisplayer));
